/* eslint-disable import/no-anonymous-default-export */
export default {
  translations: { // Mismo valor usado en las configuraciones (defaultNS)
    menu: {
      examsTitle: 'Grabaciones',
      dicomTitle: 'Imágenes',
      medicalReportsTitle: 'Informes Médicos',
      reportsTitle: 'Reportes',
      customizationTitle: 'Personalización',
      marketingTitle: 'Marketing',
      hooksFleuryTitle: 'Hooks Fleury',
      mp4ReprocessTitle: 'Reprocesar MP4',
      communicationTitle: 'Central de comunicación',
      financialTitle: 'Área financiera',
      storageTitle: 'Almacenamiento',
      goOutTitle: 'Salir',
      maternityBookletTitle: 'Libro de Maternidad',
      learnMore: 'saber más',
      user: 'Usuario',
      platform: 'Plataforma',
    },

    home: {
      noPeriodSelected: 'Ningún período seleccionado',
      notFoundData: 'Datos no encontrados.',
      errorLoadingData: 'Se produjo un error al cargar los datos.',
      tryAdmContact: '¡Contacte con su administrador!',
      timeoutError: 'El tiempo de espera de la solicitud fue excedido.',
    },

    appEnabled: {
      noData: 'Datos insuficientes.',
      insufficient_data: "Datos insuficientes.",
      clear_filters_try_again: "Limpie sus filtros e intente de nuevo",
      v_baby_fleury: "V-Baby en tu marca",
      active_brands: "Marcas Activas",
      units: "Unidades",
      installed_equipment: "Equipos Instalados",
      previous_interval: "intervalo anterior",
      curiosities: "Curiosidades",
      top_5_content_watched: "Los 5 contenidos más vistos por las mamás de su clínica:",
      most_popular_baby_name: "¿Sabes cuál es el nombre de bebé más popular?",
      other_popular_names: "Otros nombres que están de moda:",
      did_you_know_videos_podcasts: "¿Sabías? Tus mamás prefieren videos y podcasts en lugar de artículos.",
      data_not_found: "Datos insuficientes.",
      total_exams: 'Exámenes realizados',
      booking_clicks: 'Clics en agendamiento',
      exam_view_quantity: 'Visualizaciones de exámenes',
      baby_users_quantity: 'Pacientes en la App',
      articles_read: "Artículos leídos",
      videos_podcasts_watched: "Videos y podcasts vistos",
      logo_share: 'Marca Compartida',
      vbabySharesByMoms: '¡Número de veces que un video con un marco fue guardado o compartido!',
      insights: 'Insights',
      reviews: 'Valoraciones',
      overview: 'Overview',
      share: 'Compartir',
      totalRatings: 'Valoraciones totales',
      averageRatings: 'Valoración promedio de la app',
      ratingsWithComments: 'Valoraciones con comentarios',
      noRatingsFound: 'No se encontraron valoraciones',
      
      superFeedbackTooltip: 'Super feedback',
      alertFeedbackTooltip: 'Señal de alerta',
      criticalFeedbackTooltip: 'Crítico',

      vbabyContentsAccessedByMoms: 'Mira cuántos contenidos informativos de V-Baby fueron accedidos por las mamás!',
      vbabyInformationalContentViews: 'Visualizaciones de contenidos informativos V-Baby',

      vbabyExamsPatients: 'Pacientes en V-Baby y exámenes realizados',

      vbabyDailyUsageAndExams: '¡Descubra cuántas mamás ya realizaron exámenes y cuántas están usando la aplicación V-Baby por día!',

      momsFeedbacks: 'Feedbacks de las mamás',

      week: 'semana ',

      topFiveContents: 'Top 5 contenidos más vistos por las mamás:',

      readMore: 'Leer más',

      topMostWatchedContents: 'Top 5 contenidos más vistos por las mamás de su clínica:',
      momsPreferences: '¿Sabía usted?',
      videosFavorites: '¿Sabía usted? Las mamás prefieren videos y podcasts en lugar de artículos.',
      articlesFavorites: '¿Sabía usted? Las mamás prefieren artículos en lugar de videos y podcasts.',
      articlesRead: ' artículos leídos',
      videosWatched: ' videos y podcasts vistos',

      appCuriositiesMomSuccess: '¡Las curiosidades en la app están teniendo éxito con sus mamás!',
      were: 'Fueron',
      sharings: 'Fueron compartidas {{sharings}} veces',
      thisWeek: '¡sólo esta semana!',

      mostFamousFrame: 'El marco que más éxito ha tenido entre las mamás de la ',
      mostFamousFrameNotFounded: 'El marco que más éxito ha tenido entre las mamás ',

      isTheOne: 'es el de ',
      noFrameDataFounded: '¡No se encontraron datos sobre marcos!',


      mostFamousBabyName: '¿Sabe cuál es el nombre de bebé más popular por ahí?',
      is: 'Es',
      vbabyTotalFamousName: '¡Tenemos {{value}} en total en V-Baby ahora mismo!',
      othersSuccessNames: 'Otros nombres teniendo éxito:',

      vbabyViewers: '¡Sus pacientes adoraron la transmisión en vivo en V-Baby!',
      live: 'EN VIVO',
      quantityMomsParticipating: 'Sólo de {{organization}} fueron {{quantity}} mamás participando con nosotros!',
      quantityMomParticipating: 'Sólo de {{organization}} fue 1 mamá participando con nosotros!'
    },

    appDisabled: {
      total_exams: 'Exámenes realizados',
      sharingClicks: 'Clics en compartir examen',
      exam_view_quantity: 'Visualizaciones de exámenes',
      baby_users_quantity: 'Pacientes en la App',
      momsFeedbacks: 'Feedbacks de las mamás',
      score: 'Puntuación:',
      feedbackAt: '{{date}} a las {{time}}'
    },

    notFoundedPage: '¡Página no encontrada!',
    goBack: 'Volver',

    components: {
      selectOrganization: 'Seleccione una organización',
      filter: 'Filtros',
      results: 'Ver resultados',
      refreshButton: 'Actualizar',

      calendar: {
        thisMonth: 'Este mes',
        lastThirtyDays: 'Últimos 30 días',
        lastFifteenDays: 'Últimos 15 días',
        lastSevenDays: 'Últimos 7 días',
        today: 'Hoy',
        yesterday: 'Ayer',
        to: 'hasta',
        clear: 'Limpiar',
        apply: 'Aplicar'
      },

      lineChart: {
        total_exams: 'Exámenes realizados',
        vbabyPatients: 'Pacientes VBaby',
        date: 'Fecha:',
        accessDate: 'Fecha de acceso/examen',
        numberPatientsExams: 'Nº de Pacientes y Exámenes',
      },

      pagination: {
        resultsPage: 'resultados por página',
        results: 'resultados',
        "page": "página",
        "of": "de"
      },
      
      "tabs": {
        "feedbacks": "Comentarios",
        "ratings": "Valoraciones"
      },
      
      "ratings": {
        "averageRating": "Valoración promedio de la app"
      }
    },

    recap: {
      results: '¡Mira tus resultados increíbles de 2024!',
      milestones: 'Hemos reunido tus logros de este año con V-Baby.',
    },
    expiredToken: "Sesión expirada. Redirigiendo a la pantalla de inicio de sesión en 5 segundos."
  }
}
